export default {"src":"/_next/static/media/home-care-service.9aad1ec2.svg","height":343,"width":338,"blurWidth":0,"blurHeight":0};